import { localizeByKeyStatic } from "components/service";
import type { TCommunicationTask } from "./communication-types-helper";

export interface ICommunicationAiParserDetails {
  aiParserLabel: string;
  selectedParserRunLabel: string;
  selectedParserRunSummary: string;
  hasAiParserDetails: boolean;
}

export const getCommunicationAiParserDetails = (
  task: TCommunicationTask
): ICommunicationAiParserDetails => {
  const aiParserLabel =
    task.ai_provider && task.ai_model
      ? `${task.ai_provider} / ${task.ai_model}`
      : task.ai_model || task.ai_provider || "";
  const selectedParserRunLabel = task.ai_attempt && task.ai_attempt > 1
    ? localizeByKeyStatic("COMMUNICATION.AiAttempt_Value", {
      count: task.ai_attempt,
    })
    : "";
  const selectedParserRunSummary = selectedParserRunLabel
    ? `${localizeByKeyStatic("COMMUNICATION.AiParser_Selected")}: ${selectedParserRunLabel}`
    : "";

  return {
    aiParserLabel,
    selectedParserRunLabel,
    selectedParserRunSummary,
    hasAiParserDetails: Boolean(aiParserLabel || selectedParserRunLabel),
  };
};
